/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskIndustryClassification } from './ExecRiskIndustryClassification';
import {
    ExecRiskIndustryClassificationFromJSON,
    ExecRiskIndustryClassificationFromJSONTyped,
    ExecRiskIndustryClassificationToJSON,
} from './ExecRiskIndustryClassification';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedIndustryClassificationScanResponse
 */
export interface ExecRiskPaginatedIndustryClassificationScanResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedIndustryClassificationScanResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskIndustryClassification>}
     * @memberof ExecRiskPaginatedIndustryClassificationScanResponse
     */
    results: Array<ExecRiskIndustryClassification>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedIndustryClassificationScanResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedIndustryClassificationScanResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedIndustryClassificationScanResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedIndustryClassificationScanResponse interface.
 */
export function instanceOfExecRiskPaginatedIndustryClassificationScanResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedIndustryClassificationScanResponseFromJSON(json: any): ExecRiskPaginatedIndustryClassificationScanResponse {
    return ExecRiskPaginatedIndustryClassificationScanResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedIndustryClassificationScanResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedIndustryClassificationScanResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskIndustryClassificationFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedIndustryClassificationScanResponseToJSON(value?: ExecRiskPaginatedIndustryClassificationScanResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskIndustryClassificationToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

